import { List, Button } from 'devextreme-react';
import { SingleCard } from '../../layouts/single-card/single-card';
import { dsNews } from 'datasources';
import styles from './news-card.module.scss';

interface NewsItem {
  name: string;
  main_text: string;
}

export const newItem = (item:NewsItem) => (
  <div className={`${styles['news-card']}`} style={{ width: '100%' }}>
    <div className={`${styles.dx_card}`}>
      <div className={`${styles.header}`}>
        <div className={styles.title}>{item.name}</div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: item.main_text }} ></div>
    </div>
  </div>
);


interface NewsProps {
  onApprove: () => void;
}

export const News = (props: NewsProps) => (
  <SingleCard title='Новини'>
    <List
      dataSource={dsNews}
      height={500}
      width={'100%'}
      pageLoadMode="scrollBottom"
      itemRender={(item: NewsItem) => newItem(item)}
      className={styles['news-list']}
      // elementAttr={{hov} }
    />
    <Button
      onClick={props.onApprove}
      width={'100%'}
      type={'default'}
      useSubmitBehavior={false}
      text='Підтверджую'
    >
    </Button>
  </SingleCard>
);


export default News;
